import { PackageApi } from 'api-typings/memberships/memberships_types';
import {
  Package,
  _transformMembershipPackageBenefit,
  _transformMembershipPackagePrice,
} from '../recommended-membership';

export function transformMembershipPackage(packageApi: PackageApi): Package {
  return {
    id: packageApi.id,
    internalName: packageApi.internal_name,
    displayName: packageApi.display_name,
    enabled: packageApi.enabled,
    categoryId: packageApi.category_id,
    order: packageApi.order,
    benefits:
      packageApi.benefits &&
      packageApi.benefits.map(benefit =>
        _transformMembershipPackageBenefit(benefit),
      ),
    prices:
      packageApi.prices &&
      packageApi.prices.map(price => _transformMembershipPackagePrice(price)),
  };
}
